export default (min, max) => {
    const numbersInRange = [];

    for (let index = min; index <= max; index++) {
        const stringNumber = index.toString();
        stringNumber.length === 1 ? numbersInRange.push('0' + stringNumber) : numbersInRange.push(stringNumber);
    }

    return numbersInRange;
};
